import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { AuditDTO } from "../models/AuditLog/AuditDTO";
import { Parameter } from "../models/Parameter";
import { AllSettingsOptionsDTO } from "../models/Settings/AllSettingsOptionsDTO";
import { SettingEditDTO } from "../models/Settings/SettingsEditDTO";
import { SettingsListDTO } from "../models/Settings/SettingsListDTO";
import { APIService } from "./APIService";

export class SettingsService {
  async GetAll(
    searchParameters: Parameter[],
    sortingParameters: Parameter[],
    currentPage: number,
    pageSize: number
  ): Promise<PaginatedList<SettingsListDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/settingsApp/getAll`,
        {
          searchParameters,
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<SettingsListDTO>(
        false,
        "Erro ao obter a informação das Settings",
        "",
        [],
        0
      );
    }
  }

  async GetSettingsByType(searchParameters: Parameter[],
    sortingParameters: Parameter[],
    currentPage: number,
    pageSize: number): Promise<PaginatedList<SettingsListDTO>> {
    try {
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/SettingsApp/GetSettingsByType`,
        {
          searchParameters,
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new PaginatedList<SettingsListDTO>(
        false,
        "Erro ao obter a informação das Settings",
        "",
        [],
        0
      );
    }
  }

  async ExportSettings(): Promise<MessagingHelper<string>> {
    try {
      var response = await APIService.Axios().get(
        `${APIService.GetURL()}/SettingsApp/ExportSettings`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<string>(
        false,
        "Erro ao exportar as settings",
        ""
      );
    }
  }

  async GetById(id: number): Promise<MessagingHelper<SettingsListDTO | null>> {
    try {
      const response = await APIService.Axios().get(
        `${APIService.GetURL()}/settingsApp/getById/${id}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(false, "Erro ao obter a setting", null);
    }
  }

  async Edit(
    data: SettingEditDTO
  ): Promise<MessagingHelper<SettingsListDTO | null>> {
    try {
      const response = await APIService.Axios().post(
        `${APIService.GetURL()}/settingsApp/edit`,
        { ...data },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(false, "Erro ao editar a setting", null);
    }
  }

  async GetDynamicComponents(): Promise<
    MessagingHelper<SettingsListDTO | null>
  > {
    try {
      const response = await APIService.Axios().get(
        `${APIService.GetURL()}/settingsApp/GetDynamicComponents`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<null>(
        false,
        "Erro ao obter os componentes dinamicos",
        null
      );
    }
  }

  async ActiveModules(): Promise<MessagingHelper<string[]>> {
    try {
      const response = await APIService.Axios().get(`${APIService.GetURL()}/settingsApp/ActiveModules`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + APIService.GetToken(),
        },
      });
      return response.data;
    } catch (error) {
      return new MessagingHelper<string[]>(false, "Erro ao ligar ao servidor para obter o valor da setting dos módulos ativos", []);
    }
  }

  async AssistanceTypes(): Promise<MessagingHelper<string[]>> {
    try {
      const response = await APIService.Axios().get(`${APIService.GetURL()}/settingsApp/AssistanceTypes`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + APIService.GetToken(),
        },
      });
      return response.data;
    } catch (error) {
      return new MessagingHelper<string[]>(false, "Erro ao ligar ao servidor para obter o valor dos tipos de assistência", []);
    }
  }

  async ReminderStatusOptions(): Promise<MessagingHelper<string[]>> {
    try {
      const response = await APIService.Axios().get(`${APIService.GetURL()}/settingsApp/ReminderStatusOptions`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + APIService.GetToken(),
        },
      });
      return response.data;
    } catch (error) {
      return new MessagingHelper<string[]>(false, "Erro ao ligar ao servidor para obter o valor dos tipos de assistência", []);
    }
  }

  async ImportOptions(): Promise<MessagingHelper<string[]>> {
    try {
      const response = await APIService.Axios().get(`${APIService.GetURL()}/settingsApp/ImportOptions`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + APIService.GetToken(),
        },
      });
      return response.data;
    } catch (error) {
      return new MessagingHelper<string[]>(false, "Erro ao ligar ao servidor para obter o valor das opções de importação", []);
    }
  }

  async CounterOptions(): Promise<MessagingHelper<string[]>> {
    try {
      const response = await APIService.Axios().get(`${APIService.GetURL()}/settingsApp/CounterOptions`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + APIService.GetToken(),
        },
      });
      return response.data;
    } catch (error) {
      return new MessagingHelper<string[]>(false, "Erro ao ligar ao servidor para obter o valor das opções dos contadores", []);
    }
  }

  async StatusOptions(): Promise<MessagingHelper<string>> {
    try {
      const response = await APIService.Axios().get(`${APIService.GetURL()}/settingsApp/AssistanceStatusOptions`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + APIService.GetToken(),
        },
      });
      return response.data;
    } catch (error) {
      return new MessagingHelper<string>(false, "Erro ao ligar ao servidor para obter o valor das opções dos filtros", "");
    }
  }

  async NumberOfRecordsPerPageInParts(): Promise<MessagingHelper<string>> {
    try {
      const response = await APIService.Axios().get(`${APIService.GetURL()}/settingsApp/NumberOfRecordsPerPageInParts`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + APIService.GetToken(),
        },
      });
      return response.data;
    } catch (error) {
      return new MessagingHelper<string>(false, "Erro ao ligar ao servidor para obter o valor das configurações de tamanho de página das peças utilizadas", "");
    }
  }

  async GetAuditLogBySettingId(id: string | null, sortingParameters: Parameter[], currentPage: number, pageSize: number): Promise<PaginatedList<AuditDTO>> {
    try {
      const response = await APIService.Axios().post(
        `${APIService.GetURL()}/SettingsApp/GetAuditLogBySettingId?id=${id}`,
        {
          sortingParameters,
          currentPage,
          pageSize,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );

      return response.data;
    } catch (error) {
      return new PaginatedList<AuditDTO>(
        false,
        "Erro ao ligar ao servidor para obter os logs de auditoria da setting",
        "",
        [],
        0
      );
    }
  }

  async ImportSettings(csvText: string): Promise<MessagingHelper<string>> {
    try {
      const response = await APIService.Axios().post<MessagingHelper<string>>(
        `${APIService.GetURL()}/SettingsApp/ImportSettings`,
        { CsvContent: csvText },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Erro ao importar as settings";
      return new MessagingHelper<string>(false, message, "");
    }
  }
  async GetRecaptchaKey(): Promise<MessagingHelper<SettingsListDTO | null>> {
    try {
      const response = await APIService.Axios().get(
        `${APIService.GetURL()}/SettingsApp/GetRecaptchaKey`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<SettingsListDTO | null>(false, "Erro ao obter a setting por nome", null);
    }
  }
  
  async GetByName(name: string): Promise<MessagingHelper<SettingsListDTO | null>> {
    try {
      const response = await APIService.Axios().get(
        `${APIService.GetURL()}/SettingsApp/GetByName?name=${name}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<SettingsListDTO | null>(false, "Erro ao obter a setting por nome", null);
    }
  }

  async GetAllSettingsOptions(): Promise<MessagingHelper<AllSettingsOptionsDTO | null>> {
    try {
      const response = await APIService.Axios().get(
        `${APIService.GetURL()}/SettingsApp/GetAllSettingsOptions`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    } catch (error) {
      return new MessagingHelper<AllSettingsOptionsDTO | null>(
        false,
        "Erro ao obter todas as opções de settings",
        null
      );
    }
  }
}
